/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { dateOnlyToQuery } from './DateOnly';
import type {
  AppointmentExchangeDetailResponse,
  AppointmentExchangeHistoryEntryResponse,
  AppointmentExchangeResponse,
  CreateAppointmentExchangeRequest,
  ExchangeableAppointmentResponse,
  MakeAppointmentExchangeOfferRequest,
  ProblemDetails,
  UpdateAppointmentExchangeRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    AppointmentExchangeDetailResponseFromJSON,
    AppointmentExchangeDetailResponseToJSON,
    AppointmentExchangeHistoryEntryResponseFromJSON,
    AppointmentExchangeHistoryEntryResponseToJSON,
    AppointmentExchangeResponseFromJSON,
    AppointmentExchangeResponseToJSON,
    CreateAppointmentExchangeRequestFromJSON,
    CreateAppointmentExchangeRequestToJSON,
    ExchangeableAppointmentResponseFromJSON,
    ExchangeableAppointmentResponseToJSON,
    MakeAppointmentExchangeOfferRequestFromJSON,
    MakeAppointmentExchangeOfferRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateAppointmentExchangeRequestFromJSON,
    UpdateAppointmentExchangeRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface AcceptAppointmentExchangeOfferRequest {
    id: string;
    offerId: string;
}

export interface CreateAppointmentExchangeOperationRequest {
    createAppointmentExchangeRequest: CreateAppointmentExchangeRequest;
}

export interface DeleteAppointmentExchangeRequest {
    id: string;
}

export interface GetAppointmentExchangeRequest {
    id: string;
}

export interface GetAppointmentExchangeHistoryRequest {
    from?: Date;
    till?: Date;
    givenAwayByCounselorId?: string;
    exchangedWithCounselorId?: string;
}

export interface GetExchangeableAppointmentsRequest {
    from?: Date;
    till?: Date;
}

export interface MakeAppointmentExchangeOfferOperationRequest {
    id: string;
    makeAppointmentExchangeOfferRequest: MakeAppointmentExchangeOfferRequest;
}

export interface RejectAppointmentExchangeOfferRequest {
    id: string;
    offerId: string;
}

export interface UpdateAppointmentExchangeOperationRequest {
    id: string;
    updateAppointmentExchangeRequest: UpdateAppointmentExchangeRequest;
}

export interface WithdrawAppointmentExchangeOfferRequest {
    id: string;
    offerId: string;
}

/**
 * AppointmentExchangesApi - interface
 * 
 * @export
 * @interface AppointmentExchangesApiInterface
 */
export interface AppointmentExchangesApiInterface {
    /**
     * 
     * @param {string} id 
     * @param {string} offerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    acceptAppointmentExchangeOfferRaw(requestParameters: AcceptAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    acceptAppointmentExchangeOffer(requestParameters: AcceptAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {CreateAppointmentExchangeRequest} createAppointmentExchangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    createAppointmentExchangeRaw(requestParameters: CreateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeResponse>>;

    /**
     */
    createAppointmentExchange(requestParameters: CreateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    deleteAppointmentExchangeRaw(requestParameters: DeleteAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAppointmentExchange(requestParameters: DeleteAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    getAppointmentExchangeRaw(requestParameters: GetAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeDetailResponse>>;

    /**
     */
    getAppointmentExchange(requestParameters: GetAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeDetailResponse>;

    /**
     * 
     * @param {Date} [from] 
     * @param {Date} [till] 
     * @param {string} [givenAwayByCounselorId] 
     * @param {string} [exchangedWithCounselorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    getAppointmentExchangeHistoryRaw(requestParameters: GetAppointmentExchangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentExchangeHistoryEntryResponse>>>;

    /**
     */
    getAppointmentExchangeHistory(requestParameters: GetAppointmentExchangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentExchangeHistoryEntryResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    getAppointmentExchangesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentExchangeResponse>>>;

    /**
     */
    getAppointmentExchanges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentExchangeResponse>>;

    /**
     * 
     * @param {Date} [from] 
     * @param {Date} [till] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    getExchangeableAppointmentsRaw(requestParameters: GetExchangeableAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExchangeableAppointmentResponse>>>;

    /**
     */
    getExchangeableAppointments(requestParameters: GetExchangeableAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExchangeableAppointmentResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {MakeAppointmentExchangeOfferRequest} makeAppointmentExchangeOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    makeAppointmentExchangeOfferRaw(requestParameters: MakeAppointmentExchangeOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeResponse>>;

    /**
     */
    makeAppointmentExchangeOffer(requestParameters: MakeAppointmentExchangeOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeResponse>;

    /**
     * 
     * @param {string} id 
     * @param {string} offerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    rejectAppointmentExchangeOfferRaw(requestParameters: RejectAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    rejectAppointmentExchangeOffer(requestParameters: RejectAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateAppointmentExchangeRequest} updateAppointmentExchangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    updateAppointmentExchangeRaw(requestParameters: UpdateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeResponse>>;

    /**
     */
    updateAppointmentExchange(requestParameters: UpdateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeResponse>;

    /**
     * 
     * @param {string} id 
     * @param {string} offerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentExchangesApiInterface
     */
    withdrawAppointmentExchangeOfferRaw(requestParameters: WithdrawAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    withdrawAppointmentExchangeOffer(requestParameters: WithdrawAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class AppointmentExchangesApi extends runtime.BaseAPI implements AppointmentExchangesApiInterface {

    /**
     */
    async acceptAppointmentExchangeOfferRaw(requestParameters: AcceptAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling acceptAppointmentExchangeOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling acceptAppointmentExchangeOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/{id}/offers/{offerId}/accept`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async acceptAppointmentExchangeOffer(requestParameters: AcceptAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptAppointmentExchangeOfferRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createAppointmentExchangeRaw(requestParameters: CreateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeResponse>> {
        if (requestParameters['createAppointmentExchangeRequest'] == null) {
            throw new runtime.RequiredError(
                'createAppointmentExchangeRequest',
                'Required parameter "createAppointmentExchangeRequest" was null or undefined when calling createAppointmentExchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/exchanges`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAppointmentExchangeRequestToJSON(requestParameters['createAppointmentExchangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentExchangeResponseFromJSON(jsonValue));
    }

    /**
     */
    async createAppointmentExchange(requestParameters: CreateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeResponse> {
        const response = await this.createAppointmentExchangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteAppointmentExchangeRaw(requestParameters: DeleteAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAppointmentExchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAppointmentExchange(requestParameters: DeleteAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAppointmentExchangeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAppointmentExchangeRaw(requestParameters: GetAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAppointmentExchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentExchangeDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAppointmentExchange(requestParameters: GetAppointmentExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeDetailResponse> {
        const response = await this.getAppointmentExchangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAppointmentExchangeHistoryRaw(requestParameters: GetAppointmentExchangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentExchangeHistoryEntryResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = dateOnlyToQuery(requestParameters['from'] as Date);
        }

        if (requestParameters['till'] != null) {
            queryParameters['till'] = dateOnlyToQuery(requestParameters['till'] as Date);
        }

        if (requestParameters['givenAwayByCounselorId'] != null) {
            queryParameters['givenAwayByCounselorId'] = requestParameters['givenAwayByCounselorId'];
        }

        if (requestParameters['exchangedWithCounselorId'] != null) {
            queryParameters['exchangedWithCounselorId'] = requestParameters['exchangedWithCounselorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/history`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentExchangeHistoryEntryResponseFromJSON));
    }

    /**
     */
    async getAppointmentExchangeHistory(requestParameters: GetAppointmentExchangeHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentExchangeHistoryEntryResponse>> {
        const response = await this.getAppointmentExchangeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAppointmentExchangesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentExchangeResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentExchangeResponseFromJSON));
    }

    /**
     */
    async getAppointmentExchanges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentExchangeResponse>> {
        const response = await this.getAppointmentExchangesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getExchangeableAppointmentsRaw(requestParameters: GetExchangeableAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExchangeableAppointmentResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = dateOnlyToQuery(requestParameters['from'] as Date);
        }

        if (requestParameters['till'] != null) {
            queryParameters['till'] = dateOnlyToQuery(requestParameters['till'] as Date);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/exchangeable-appointments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExchangeableAppointmentResponseFromJSON));
    }

    /**
     */
    async getExchangeableAppointments(requestParameters: GetExchangeableAppointmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExchangeableAppointmentResponse>> {
        const response = await this.getExchangeableAppointmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async makeAppointmentExchangeOfferRaw(requestParameters: MakeAppointmentExchangeOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling makeAppointmentExchangeOffer().'
            );
        }

        if (requestParameters['makeAppointmentExchangeOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'makeAppointmentExchangeOfferRequest',
                'Required parameter "makeAppointmentExchangeOfferRequest" was null or undefined when calling makeAppointmentExchangeOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/exchanges/{id}/offers`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MakeAppointmentExchangeOfferRequestToJSON(requestParameters['makeAppointmentExchangeOfferRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentExchangeResponseFromJSON(jsonValue));
    }

    /**
     */
    async makeAppointmentExchangeOffer(requestParameters: MakeAppointmentExchangeOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeResponse> {
        const response = await this.makeAppointmentExchangeOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async rejectAppointmentExchangeOfferRaw(requestParameters: RejectAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rejectAppointmentExchangeOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling rejectAppointmentExchangeOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/{id}/offers/{offerId}/reject`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async rejectAppointmentExchangeOffer(requestParameters: RejectAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectAppointmentExchangeOfferRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAppointmentExchangeRaw(requestParameters: UpdateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentExchangeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAppointmentExchange().'
            );
        }

        if (requestParameters['updateAppointmentExchangeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAppointmentExchangeRequest',
                'Required parameter "updateAppointmentExchangeRequest" was null or undefined when calling updateAppointmentExchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/exchanges/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAppointmentExchangeRequestToJSON(requestParameters['updateAppointmentExchangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentExchangeResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAppointmentExchange(requestParameters: UpdateAppointmentExchangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentExchangeResponse> {
        const response = await this.updateAppointmentExchangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async withdrawAppointmentExchangeOfferRaw(requestParameters: WithdrawAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling withdrawAppointmentExchangeOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling withdrawAppointmentExchangeOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/exchanges/{id}/offers/{offerId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async withdrawAppointmentExchangeOffer(requestParameters: WithdrawAppointmentExchangeOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.withdrawAppointmentExchangeOfferRaw(requestParameters, initOverrides);
    }

}
